const tabs = new Set(["home", "shop", "arena", "king-of-the-hill", "collection", "profile"]);
const homeViews = new Set([
  "rating", "summer", "fishing", "metapass", "minigames",
  "halloween-event", "halloween", "penalty", "vabank",
]);

export function resolveDestination(value) {
  if (typeof value !== "string") return null;
  const rawPage = value.startsWith("page_") ? value.slice(5) : value;
  const page = rawPage === "king_of_the_hill" ? "king-of-the-hill" : rawPage;
  const state = { tab: "home", homeView: "main", casesOpen: false, walletOpen: false };
  if (tabs.has(page)) return { ...state, tab: page };
  if (homeViews.has(page)) return { ...state, homeView: page };
  if (page === "cases") return { ...state, casesOpen: true };
  if (page === "wallet") return { ...state, tab: "profile", walletOpen: true };
  return null;
}

export function resolveLaunchNavigation({ search = "", telegram = {}, reload = false, savedTab = null } = {}) {
  const query = new URLSearchParams(search);
  // Launch data selects a screen only. Authentication always uses the existing session flow.
  const candidates = [
    telegram.initDataUnsafe?.start_param,
    new URLSearchParams(telegram.initData || "").get("start_param"),
    query.get("tgWebAppStartParam"),
    query.get("page"),
  ];
  for (const candidate of candidates) {
    const destination = resolveDestination(candidate);
    if (destination) return destination;
  }
  return resolveDestination(reload && tabs.has(savedTab) ? savedTab : "home");
}

export function initialNavigation() {
  const navigation = performance.getEntriesByType("navigation")[0];
  const legacyNavigation = performance.navigation;
  const reload = navigation?.type === "reload"
    || (legacyNavigation !== undefined && legacyNavigation.type === legacyNavigation.TYPE_RELOAD);
  let savedTab = null;
  try { savedTab = sessionStorage.getItem("metacard-active-tab"); } catch { /* Storage can be disabled. */ }
  return resolveLaunchNavigation({
    search: window.location.search,
    telegram: window.Telegram?.WebApp,
    reload,
    savedTab,
  });
}
